module.exports = __webpack_public_path__ + "cda4568242c75b3f71d01b8cab548da2.MP3";